import {css} from "@panda/css";

import {Placeholder} from "@pg-design/image-module";
import {Picture} from "@pg-design/picture-module";
import {Text} from "@pg-design/text-module";

import {SeoMainHeadline} from "../../../atoms/SeoMainHeadline";
import {IRegionReportPrice} from "../../../region/types/IRegionReportPrice";
import {HeaderBox, HeaderBoxType} from "../atoms/HeaderBox";
import {getHeaderPictures} from "../helpers/get_header_pictures";
import {PricesViewType} from "../helpers/prices_view_type";
import {getPricesTextFromType} from "../utils/get_from_prices_type";
import {usePricesHeaderData} from "../utils/use_prices_header_data";

interface IProps {
    type: PricesViewType;
    region?: IRegionReportPrice;
}

export const PricesHeader = (props: IProps) => {
    const pictures = getHeaderPictures(props.region?.slug);

    const {dateLabel, dataToRender} = usePricesHeaderData(props.region?.slug);

    return (
        <div className={headerHolderStyle}>
            <div className={textHolderStyle}>
                <SeoMainHeadline variant="headline_1" align="center" className={headlineStyle} highlight prefixContent="Poznaj średnie">
                    {getPricesTextFromType(props.type)} {props.region?.name_declension_where || "w Polsce"}
                </SeoMainHeadline>
                {dateLabel && (
                    <Text as="span" variant="body_copy_0">
                        {dateLabel}
                    </Text>
                )}
            </div>

            {pictures ? (
                <Picture
                    sources={[
                        {minWidthPX: 0, src: pictures.xs, height: 360, width: 448},
                        {minWidthPX: 360, src: pictures.sm, height: 600, width: 448},
                        {minWidthPX: 600, src: pictures.md, height: 588, width: 1366},
                        {minWidthPX: 1366, src: pictures.lg, height: 826, width: 1919},
                        {minWidthPX: 1919, src: pictures.xl, height: 1102, width: 2560}
                    ]}
                    alt="header"
                />
            ) : (
                <div className={placeholderStyle}>
                    <Placeholder />
                </div>
            )}

            {dataToRender && (
                <div className={boxesHolderStyle}>
                    <HeaderBox type={HeaderBoxType.PRICE_M2} data={dataToRender.avr_price_m2} />

                    {/* median tile - city views only, and only when both the current and the year-ago median are available */}
                    {dataToRender.median_price_m2 && <HeaderBox type={HeaderBoxType.MEDIAN_PRICE_M2} data={dataToRender.median_price_m2} />}

                    <HeaderBox type={HeaderBoxType.PRICE} data={dataToRender.avr_price} />

                    <HeaderBox type={HeaderBoxType.FLATS_COUNT} data={dataToRender.offers_count} />
                </div>
            )}
        </div>
    );
};

const headerHolderStyle = css({
    marginBottom: 5,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column"
});

const textHolderStyle = css({
    my: 4,
    mx: 1.5,
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "center",
    flexDirection: "column",
    md: {
        mx: 0,
        alignItems: "center"
    }
});

const headlineStyle = css({
    marginBottom: 1
});

const boxesHolderStyle = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 3,
    flexDirection: "column",
    transform: "translateY(-15%)",
    px: 2,
    width: "100%",
    md: {
        flexDirection: "row",
        transform: "translateY(-50%)"
    }
});

const placeholderStyle = css({
    width: "100%",
    minHeight: "420px",
    position: "relative"
});
import {css} from "@panda/css";

import {Placeholder} from "@pg-design/image-module";
import {Picture} from "@pg-design/picture-module";
import {Text} from "@pg-design/text-module";

import {SeoMainHeadline} from "../../../atoms/SeoMainHeadline";
import {IRegionReportPrice} from "../../../region/types/IRegionReportPrice";
import {HeaderBox, HeaderBoxType} from "../atoms/HeaderBox";
import {getHeaderPictures} from "../helpers/get_header_pictures";
import {PricesViewType} from "../helpers/prices_view_type";
import {getPricesTextFromType} from "../utils/get_from_prices_type";
import {usePricesHeaderData} from "../utils/use_prices_header_data";

interface IProps {
    type: PricesViewType;
    region?: IRegionReportPrice;
}

export const PricesHeader = (props: IProps) => {
    const pictures = getHeaderPictures(props.region?.slug);

    const {dateLabel, dataToRender} = usePricesHeaderData(props.region?.slug);

    return (
        <div className={headerHolderStyle}>
            <div className={textHolderStyle}>
                <SeoMainHeadline variant="headline_1" align="center" className={headlineStyle} highlight prefixContent="Poznaj średnie">
                    {getPricesTextFromType(props.type)} {props.region?.name_declension_where || "w Polsce"}
                </SeoMainHeadline>
                {dateLabel && (
                    <Text as="span" variant="body_copy_0">
                        {dateLabel}
                    </Text>
                )}
            </div>

            {pictures ? (
                <Picture
                    sources={[
                        {minWidthPX: 0, src: pictures.xs, height: 360, width: 448},
                        {minWidthPX: 360, src: pictures.sm, height: 600, width: 448},
                        {minWidthPX: 600, src: pictures.md, height: 588, width: 1366},
                        {minWidthPX: 1366, src: pictures.lg, height: 826, width: 1919},
                        {minWidthPX: 1919, src: pictures.xl, height: 1102, width: 2560}
                    ]}
                    alt="header"
                />
            ) : (
                <div className={placeholderStyle}>
                    <Placeholder />
                </div>
            )}

            {dataToRender && (
                <div className={boxesHolderStyle}>
                    <HeaderBox type={HeaderBoxType.PRICE_M2} data={dataToRender.avr_price_m2} />

                    {/* median tile - city views only, and only when both the current and the year-ago median are available */}
                    {dataToRender.median_price_m2 && <HeaderBox type={HeaderBoxType.MEDIAN_PRICE_M2} data={dataToRender.median_price_m2} />}

                    <HeaderBox type={HeaderBoxType.PRICE} data={dataToRender.avr_price} />

                    <HeaderBox type={HeaderBoxType.FLATS_COUNT} data={dataToRender.offers_count} />
                </div>
            )}
        </div>
    );
};

const headerHolderStyle = css({
    marginBottom: 5,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column"
});

const textHolderStyle = css({
    my: 4,
    mx: 1.5,
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "center",
    flexDirection: "column",
    md: {
        mx: 0,
        alignItems: "center"
    }
});

const headlineStyle = css({
    marginBottom: 1
});

const boxesHolderStyle = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 3,
    flexDirection: "column",
    transform: "translateY(-15%)",
    px: 2,
    width: "100%",
    md: {
        flexDirection: "row",
        transform: "translateY(-50%)"
    }
});

const placeholderStyle = css({
    width: "100%",
    minHeight: "420px",
    position: "relative"
});
